import { styled } from "@mui/system"
import { useUser } from "hooks/useUser"
import React from "react"

interface WherebyProps {
  meetingUrl: string
}

const Whereby = (props: WherebyProps) => {
  const { meetingUrl } = props

  const user = useUser()
  const src = new URL(meetingUrl)

  // NOTE: https://docs.google.com/spreadsheets/d/1WVkDh_6iiJ2gj0iK-MQTFGNOWBhAm9-hDNhH59b-UKs/edit#gid=0
  src.searchParams.append("breakout", "on")
  src.searchParams.append("chat", "on")
  if (user) {
    src.searchParams.append("displayName", user.first_name + " " + user.last_name)
    src.searchParams.append("metadata", user.id)
  }
  src.searchParams.append("lang", "us-en")
  src.searchParams.append("leaveButton", "on")
  src.searchParams.append("locking", "off")
  src.searchParams.append("logo", "off")
  src.searchParams.append("moreButton", "off")
  src.searchParams.append("participantCount", "off")
  src.searchParams.append("people", "off")
  src.searchParams.append("screenshare", "on")
  src.searchParams.append("settingsButton", "off")
  src.searchParams.append("subgridLabels", "off")
  src.searchParams.append("timer", "off")
  src.searchParams.append("video", "off")

  return (
    <_IFrame
      src={src.toString()}
      allow="camera; microphone; fullscreen; speaker; display-capture"
    />
  )
}

export default Whereby

const _IFrame = styled("iframe")({
  width: "100%",
  height: "100%",
  padding: 0,
  border: "none",
})
